/**
 * Canonical sealed product type labels and formatting.
 * Used across Browse, BulkPost, CardIdentify, AdminSealedProducts, ProductViewRedesign, etc.
 */
export var SEALED_TYPE_LABELS = {
  booster_box: 'Booster Box',
  booster_pack: 'Booster Pack',
  starter_deck: 'Starter Deck',
  anniversary_box: 'Anniversary Box',
};

/**
 * Formats a sealed type slug to a display label.
 * Known types use the canonical map; custom types are converted from snake_case to Title Case.
 */
export function formatSealedType(type) {
  if (!type) return 'Sealed';
  if (SEALED_TYPE_LABELS[type]) return SEALED_TYPE_LABELS[type];
  return type.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
}
